import styled from 'react-emotion';
import BaseInput from '@material-ui/core/Input';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import IconButton from '@ublend-npm/aulaui-next-web/IconButton';

export const className = {
  inputFocus: 'inputFocus',
};

export const Container = styled('div')`
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  flex: 1 1;
  width: 100%;
  & > div,
  & > svg {
    margin-right: 8px;
  }
`;

export const ParentContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;

  width: 100%;
  box-sizing: border-box;
  font-size: ${theme.font.size.copy};
  color: ${colors.designSystem.blackOpacity60};

  svg.searchIcon {
    color: ${colors.designSystem.blackOpacity60};
    padding-left: ${theme.spacing.small};
  }

  border: 1px solid ${colors.designSystem.blackOpacity38};
  border-radius: ${theme.borderRadius.medium};
  padding: ${theme.spacing.xxSmall} 1px;
  margin-bottom: 17px;
  margin-right: 20px;
  height: 100%;
  &.inputFocus {
    border: 2px solid ${colors.designSystem.purple70};
    min-width: 40px;
  }
`;

export const Input = styled(BaseInput)`
  width: 100%;
  color: ${colors.designSystem.blackOpacity87};
  font-size: ${theme.font.size.copy};
  font-family: ${theme.font.family.workSans};
  flex: 1 1;
  min-width: 50px;
`;

export const CancelButton = styled(IconButton)`
  background: transparent;
  color: ${colors.designSystem.blackOpacity87};

  svg {
    opacity: 1;
  }

  &:hover {
    background-color: ${colors.beige};
    opacity: 0.5;
  }
`;
